import React, { useContext } from 'react'
import { EPCRContext } from '../EPCR'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material'
import { welfareCategories, welfareOutcomes } from './welfareOptions'

const WelfareDetails = () => {
  const { formValues, handleChange } = useContext(EPCRContext)

  const updateWelfare = (field) => (e) =>
    handleChange({ moduleName: 'welfare', field, value: e.target.value })

  const updateDemographics = (field) => (e) =>
    handleChange({ moduleName: 'demographics', field, value: e.target.value })

  return (
    <>
      <EPCRCard>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="title2">Welfare Details</Typography>
          </Grid>
          <Grid item xs={12} lg={4}>
            <FormControl fullWidth>
              <InputLabel>Category</InputLabel>
              <Select
                label="Category"
                value={formValues?.welfare?.category ?? ''}
                onChange={updateWelfare('category')}
              >
                {welfareCategories.map((category) => (
                  <MenuItem key={category} value={category}>
                    {category}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="What Happened"
              multiline
              fullWidth
              minRows={3}
              value={formValues?.welfare?.details ?? ''}
              onChange={updateWelfare('details')}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Actions Taken"
              multiline
              fullWidth
              minRows={2}
              value={formValues?.welfare?.actionsTaken ?? ''}
              onChange={updateWelfare('actionsTaken')}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <FormControl fullWidth>
              <InputLabel>Outcome</InputLabel>
              <Select
                label="Outcome"
                value={formValues?.welfare?.outcome ?? ''}
                onChange={updateWelfare('outcome')}
              >
                {welfareOutcomes.map((outcome) => (
                  <MenuItem key={outcome} value={outcome}>
                    {outcome}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Outcome Notes"
              multiline
              fullWidth
              minRows={2}
              value={formValues?.welfare?.outcomeNotes ?? ''}
              onChange={updateWelfare('outcomeNotes')}
            />
          </Grid>
        </Grid>
      </EPCRCard>
      <EPCRCard>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="title2">Person Involved (Optional)</Typography>
            <Typography variant="caption">
              Record whoever this welfare record concerns, where known — for
              example a lost child, or the owner of found property.
            </Typography>
          </Grid>
          <Grid item xs={12} lg={4}>
            <TextField
              label="First Name"
              fullWidth
              value={formValues?.demographics?.firstName ?? ''}
              onChange={updateDemographics('firstName')}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <TextField
              label="Last Name"
              fullWidth
              value={formValues?.demographics?.lastName ?? ''}
              onChange={updateDemographics('lastName')}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <TextField
              label="Contact Number"
              fullWidth
              value={formValues?.demographics?.contactNumber ?? ''}
              onChange={updateDemographics('contactNumber')}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Description (appearance, clothing, distinguishing features)"
              multiline
              fullWidth
              minRows={2}
              value={formValues?.welfare?.personDescription ?? ''}
              onChange={updateWelfare('personDescription')}
            />
          </Grid>
        </Grid>
      </EPCRCard>
    </>
  )
}

export default WelfareDetails
